import { IAccount } from "../../../common/accounts2";
import { $SiteColors } from "../../../common/config/company-atts";
import { empty, kopecks2rubStr } from "../../../common/functions";

interface IKapRemontTotalByMonthBlock {
  syncAcc: IAccount;
}

//отрисовываем данные по последнему начислению капремонта
export const KapRemontTotalByMonthBlock = ({
  syncAcc,
}: IKapRemontTotalByMonthBlock) => {
  let totalsByMonth = syncAcc.totalByMonth;
  if (empty(totalsByMonth)) return <></>;
  let total = totalsByMonth[0].monthAmount;

  return (
    <div className="payment__container">
      <div className="payment__title">&thinsp;</div>
      <div className="payment__numbers-button">
        <p className="payment__text">{kopecks2rubStr(total)}</p>
        <button
          type="button"
          className="payment__button"
          style={{ backgroundColor: $SiteColors.getState().backBtnTotalByMonth }}
        >
          Посмотреть
        </button>
      </div>
    </div>
  );
};
